module.exports = __webpack_public_path__ + "static/media/signup1.af2f5029.png";